import { store } from '@redux/store';
import { filter, fromEvent } from "rxjs";
import { onArticleCountResultsLoaded$, articleSearchResultsActions } from 'features/articleSearchResultsFacets';

const pageSizeElement = document.querySelector('[data-page-size]');
const pageSizeChange$ = fromEvent(pageSizeElement, 'change');

// function to update the page size property of the state
const updatePageSize = function (event) {
  const newPageSize = Number(event.target?.value || 40);
  store.dispatch(articleSearchResultsActions.updatePageSizeParameter(newPageSize));
}

pageSizeChange$.subscribe(updatePageSize);

// function to reset the page size component to the first initial value
const resetPageSizeComponent = function(){
  pageSizeElement.selectedIndex = 0;
};

// observer to know if there are new search results
const newCountResults$ = onArticleCountResultsLoaded$.pipe(
  filter((countResults) => countResults > 20),
);

newCountResults$.subscribe(resetPageSizeComponent);